const base64ToBytes = (base64: string): Uint8Array => {
  return new Uint8Array(
    atob(base64)
      .split("")
      .map((char) => char.charCodeAt(0))
  );
};

async function importPublicKey(publicKeyBase64: string): Promise<CryptoKey> {
  const binaryKey = base64ToBytes(publicKeyBase64);

  return window.crypto.subtle.importKey(
    "spki",
    binaryKey,
    {
      name: "RSA-OAEP",
      hash: "SHA-256",
    },
    false,
    ["encrypt"]
  );
}

export async function encryptWithRSA(
  aesKey: string,
  iv: string,
  publicKey: string
): Promise<{ encryptedAesKey: string; encryptedIv: string }> {
  const cryptoKey = await importPublicKey(publicKey);

  const encryptedAesKey = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    cryptoKey,
    base64ToBytes(aesKey)
  );

  const encryptedIv = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    cryptoKey,
    base64ToBytes(iv)
  );

  return {
    encryptedAesKey: btoa(String.fromCharCode(...new Uint8Array(encryptedAesKey))),
    encryptedIv: btoa(String.fromCharCode(...new Uint8Array(encryptedIv))),
  };
}
